import swal from 'sweetalert2';


export function ajaxHandler(error) {
    console.log("----ERROR----");
    console.log(JSON.stringify(error));

    if (error.message && error.message === 'abort') {
        return false;
    }

    if (!error.response) {
        /*
        swal({
            title: 'Error en la conexión',
            text: "No se pudo establecer una comunicación con el servidor. Por favor, revise su conexión y vuelva a intentarlo.",
            type: 'error',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
        */
        return false;
    }

    let response = error.response;

    if (!(response.hasOwnProperty('status'))) {
        return false;
    }

    let status = response.status;

    if (status === 400) {
        let keys = Object.keys(response.data);
        let details = [];
        for (let i in keys) {
            details.push({
                key: keys[i],
                text: response.data[keys[i]].join(' ')
            });
        }
        let text = ``;
        details.map(d => {
            return text = text + `${d.key}: ${d.text} \n`
        });


        swal({
            title: 'Error',
            text: `${text}`,
            type: 'error',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });

        return false;
    }

    if (status === 401) {
        swal({
            title: 'Sesión expirada',
            text: "Por favor, ingrese al sistema nuevamente",
            type: 'warning',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
        setTimeout(() => {
            localStorage.clear();
            window.location = '/';
        }, 3000);
        return false;
    }

    if (status === 403) {
        swal({
            title: 'Permiso denegado',
            text: "Su usuario no cuenta con los permisos necesarios",
            type: 'warning',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
        return false;
    }

    if (status === 404) {
        swal({
            title: 'Ruta no encontrada',
            text: "No se pudo encontrar la ruta ingresada, o el link ha expirado.",
            type: 'warning',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
        return false;
    }

    if (status === 500) {
        swal({
            title: 'Error en el servidor',
            text: "Se produjo un error inesperado en el servidor. Los administradores ya fueron notificados; inténte nuevamente más tarde.",
            type: 'error',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/utils/errors.js